import React, { useState } from 'react';

const FAMILY_PHOTOS = [
  { 
    id: 1, 
    filename: 'family pic.JPG', 
    title: 'Family Photo',
    category: 'family',
    tags: ['everyone', 'group']
  },
  { 
    id: 2, 
    filename: 'family.JPG', 
    title: 'Family',
    category: 'family',
    tags: ['everyone', 'group']
  },
  { 
    id: 3, 
    filename: 'family2.jpg', 
    title: 'Family Together',
    category: 'family',
    tags: ['everyone', 'group']
  },
  { 
    id: 4, 
    filename: 'mom&dad.jpg', 
    title: 'Mom & Dad',
    category: 'parents',
    tags: ['viji', 'jeyakumar', 'parents']
  },
  { 
    id: 5, 
    filename: 'brothers.JPG', 
    title: 'Brothers',
    category: 'siblings',
    tags: ['rujaiananth', 'prajit', 'thamoj', 'brothers']
  },
  { 
    id: 6, 
    filename: 'brothers2.JPG', 
    title: 'Brothers Together',
    category: 'siblings',
    tags: ['rujaiananth', 'prajit', 'thamoj', 'brothers']
  },
  { 
    id: 7, 
    filename: 'brothers3.JPG', 
    title: 'Brothers Fun',
    category: 'siblings',
    tags: ['rujaiananth', 'prajit', 'thamoj', 'brothers']
  },
  { 
    id: 8, 
    filename: 'rujaiananth.JPG', 
    title: 'Rujai Ananth',
    category: 'individual',
    tags: ['rujaiananth']
  },
  { 
    id: 9, 
    filename: 'rujaiananth2.JPG', 
    title: 'Rujai Ananth',
    category: 'individual',
    tags: ['rujaiananth']
  },
  { 
    id: 10, 
    filename: 'prajit.JPG', 
    title: 'Prajit Kannan',
    category: 'individual',
    tags: ['prajit']
  },
  { 
    id: 11, 
    filename: 'thamoj.jpeg', 
    title: 'Thamoj Karthic',
    category: 'individual',
    tags: ['thamoj']
  },
  { 
    id: 12, 
    filename: 'jeyakumar.PNG', 
    title: 'Jeyakumar',
    category: 'individual',
    tags: ['jeyakumar', 'dad']
  },
  { 
    id: 13, 
    filename: 'viji.JPG', 
    title: 'Viji',
    category: 'individual',
    tags: ['viji', 'mom']
  }
];

export default function FamilyGallery() {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [filter, setFilter] = useState('all');
  const [view, setView] = useState('grid'); // grid or slideshow
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const slideIntervalRef = React.useRef(null);
  const progressIntervalRef = React.useRef(null);
  const SLIDE_DURATION = 3000; // 3 seconds per slide

  const getPhotoPath = (filename) => {
    return `${process.env.PUBLIC_URL || ''}/Family Pics/${filename}`;
  };

  const filteredPhotos = filter === 'all' 
    ? FAMILY_PHOTOS 
    : FAMILY_PHOTOS.filter(photo => photo.category === filter);

  const openLightbox = (photo) => {
    setSelectedPhoto(photo);
  };

  const closeLightbox = () => {
    setSelectedPhoto(null);
  };

  const showNext = () => {
    if (!selectedPhoto) return;
    const currentIndex = filteredPhotos.findIndex(p => p.id === selectedPhoto.id);
    const nextIndex = (currentIndex + 1) % filteredPhotos.length;
    setSelectedPhoto(filteredPhotos[nextIndex]);
  };

  const showPrevious = () => {
    if (!selectedPhoto) return;
    const currentIndex = filteredPhotos.findIndex(p => p.id === selectedPhoto.id);
    const prevIndex = (currentIndex - 1 + filteredPhotos.length) % filteredPhotos.length;
    setSelectedPhoto(filteredPhotos[prevIndex]);
  };

  const handleKeyDown = (e) => {
    if (!selectedPhoto) return;
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrevious();
    if (e.key === 'Escape') closeLightbox();
  };

  React.useEffect(() => {
    if (selectedPhoto) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [selectedPhoto]);

  // Slideshow auto-play logic
  React.useEffect(() => {
    if (view === 'slideshow' && isPlaying && filteredPhotos.length > 0) {
      // Progress bar animation
      setProgress(0);
      let progressValue = 0;
      progressIntervalRef.current = setInterval(() => {
        progressValue += (100 / SLIDE_DURATION) * 50; // Update every 50ms
        setProgress(progressValue);
        if (progressValue >= 100) {
          clearInterval(progressIntervalRef.current);
        }
      }, 50);

      // Slide transition
      slideIntervalRef.current = setTimeout(() => {
        setCurrentSlideIndex((prev) => (prev + 1) % filteredPhotos.length);
      }, SLIDE_DURATION);

      return () => {
        if (slideIntervalRef.current) clearTimeout(slideIntervalRef.current);
        if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      };
    } else {
      setProgress(0);
    }
  }, [view, isPlaying, currentSlideIndex, filteredPhotos.length]);

  // Reset slideshow when view or filter changes
  React.useEffect(() => {
    setCurrentSlideIndex(0);
    setProgress(0);
    if (view === 'slideshow') {
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  }, [view, filter]);

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const goToSlide = (index) => {
    setCurrentSlideIndex(index);
    setProgress(0);
  };

  const nextSlide = () => {
    setCurrentSlideIndex((prev) => (prev + 1) % filteredPhotos.length);
    setProgress(0);
  };

  const prevSlide = () => {
    setCurrentSlideIndex((prev) => (prev - 1 + filteredPhotos.length) % filteredPhotos.length);
    setProgress(0);
  };

  return (
    <div className="family-gallery-page">
      <div className="gallery-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="#c9a62b" strokeWidth="1.5" fill="rgba(201,166,43,0.1)"/>
            <circle cx="8.5" cy="8.5" r="1.5" fill="#c9a62b"/>
            <path d="M3 15l5-5 4 4 5-5 4 4v6H3v-4z" fill="rgba(201,166,43,0.3)"/>
          </svg>
          <div>
            <h1 style={{ margin: 0 }}>Family Gallery</h1>
            <p style={{ margin: 0 }}>Precious moments and memories</p>
          </div>
        </div>
      </div>

      <div className="gallery-controls">
        <div className="filter-tabs">
          <button 
            className={filter === 'all' ? 'active' : ''} 
            onClick={() => setFilter('all')}
          >
            All Photos ({FAMILY_PHOTOS.length})
          </button>
          <button 
            className={filter === 'family' ? 'active' : ''} 
            onClick={() => setFilter('family')}
          >
            Family
          </button>
          <button 
            className={filter === 'parents' ? 'active' : ''} 
            onClick={() => setFilter('parents')}
          >
            Parents
          </button>
          <button 
            className={filter === 'siblings' ? 'active' : ''} 
            onClick={() => setFilter('siblings')}
          >
            Brothers
          </button>
          <button 
            className={filter === 'individual' ? 'active' : ''} 
            onClick={() => setFilter('individual')}
          >
            Individual
          </button>
        </div>

        <div className="view-toggle">
          <button 
            className={view === 'grid' ? 'active' : ''} 
            onClick={() => setView('grid')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
              <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
              <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
              <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            Grid
          </button>
          <button 
            className={view === 'slideshow' ? 'active' : ''} 
            onClick={() => setView('slideshow')}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M7 21h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              <path d="M10 10l5-3v6l-5-3z" fill="currentColor"/>
            </svg>
            Slideshow
          </button>
        </div>
      </div>

      {view === 'grid' ? (
        <>
          <div className="photo-grid">
            {filteredPhotos.map(photo => (
              <div 
                key={photo.id} 
                className="photo-card"
                onClick={() => openLightbox(photo)}
              >
                <img 
                  src={getPhotoPath(photo.filename)} 
                  alt={photo.title}
                  loading="lazy"
                />
                <div className="photo-overlay">
                  <span className="photo-title">{photo.title}</span>
                </div>
              </div>
            ))}
          </div>

          {filteredPhotos.length === 0 && (
            <div className="no-photos">
              <p>No photos in this category</p>
            </div>
          )}
        </>
      ) : (
        <div className="slideshow-container">
          {filteredPhotos.length > 0 && (
            <>
              {/* Main Slide */}
              <div className="slideshow-main">
                <img 
                  src={getPhotoPath(filteredPhotos[currentSlideIndex].filename)} 
                  alt={filteredPhotos[currentSlideIndex].title}
                  className="slideshow-image"
                />
                
                {/* Slide Info Overlay */}
                <div className="slideshow-info">
                  <h3>{filteredPhotos[currentSlideIndex].title}</h3>
                  <p>{currentSlideIndex + 1} / {filteredPhotos.length}</p>
                </div>

                {/* Navigation Arrows */}
                <button className="slideshow-nav slideshow-prev" onClick={prevSlide}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button className="slideshow-nav slideshow-next" onClick={nextSlide}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>

              {/* Progress Bar */}
              <div className="slideshow-progress-bar">
                <div 
                  className="slideshow-progress-fill" 
                  style={{ width: `${progress}%` }}
                />
              </div>

              {/* Controls */}
              <div className="slideshow-controls">
                <button 
                  className="slideshow-play-pause"
                  onClick={togglePlayPause}
                >
                  {isPlaying ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor"/>
                      <rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor"/>
                    </svg>
                  ) : (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 5v14l11-7z" fill="currentColor"/>
                    </svg>
                  )}
                </button>

                <span className="slideshow-counter">
                  {currentSlideIndex + 1} / {filteredPhotos.length}
                </span>

                <button 
                  className="slideshow-exit"
                  onClick={() => setView('grid')}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>
              </div>

              {/* Thumbnail Strip */}
              <div className="slideshow-thumbnails">
                {filteredPhotos.map((photo, index) => (
                  <div
                    key={photo.id}
                    className={`slideshow-thumbnail ${index === currentSlideIndex ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                  >
                    <img 
                      src={getPhotoPath(photo.filename)} 
                      alt={photo.title}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {selectedPhoto && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>✕</button>
            <button className="lightbox-prev" onClick={showPrevious}>‹</button>
            <button className="lightbox-next" onClick={showNext}>›</button>
            
            <img 
              src={getPhotoPath(selectedPhoto.filename)} 
              alt={selectedPhoto.title}
            />
            
            <div className="lightbox-info">
              <h3>{selectedPhoto.title}</h3>
              <div className="photo-tags">
                {selectedPhoto.tags.map(tag => (
                  <span key={tag} className="tag">{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
